import type { TableView } from "owa-mail-list-store";
import { action } from "satcheljs";

export interface RELOAD_TABLE_ON_TRIAGE_ACTION_FAILActionMessage {
    tableView: TableView;
}
const defaultExport: (tableView: TableView) => RELOAD_TABLE_ON_TRIAGE_ACTION_FAILActionMessage = action("RELOAD_TABLE_ON_TRIAGE_ACTION_FAIL", (tableView: TableView): RELOAD_TABLE_ON_TRIAGE_ACTION_FAILActionMessage => {
    return {
        tableView,
    };
});
export default defaultExport;
